module.exports = __webpack_public_path__ + "SravyaReddy-fb848db0.webp";